import React from "react";

const { compose } = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} = require("react-google-maps");

const MapWithAMarker = compose(withScriptjs, withGoogleMap)(props => (
  <GoogleMap defaultZoom={13} defaultCenter={{ lat: 50.0026, lng: 20.9188}}>
    <Marker position={{ lat: 50.0026, lng: 20.9188 }} />
  </GoogleMap>
));

export default MapWithAMarker;



// WEBPACK FOOTER //
// ./src/containers/Map/Map.js